export const LiveStream = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="7" width="26" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
<path d="M13 20V12L20 16L13 20Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
